module.exports = __webpack_public_path__ + "static/media/edgeConn.2370f61f.gif";